import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import Field, { FieldType } from 'packages/kakapo-ui-kit/components/forms/controls/Field';

import EmployeesDepartmentFilter from './EmployeesDepartmentFilter';
import EmployeesStatusFilter from './EmployeesStatusFilter';
import EmployeesCycleFilter from './filters/EmployeesCycleFitler';
import EmployeesExternalFilter from './filters/EmployeesExternalFilter';
import EmployeesJobFilter from './filters/EmployeesJobFilter';

const SearchField = styled(Field)`
	border-radius: 20px;
	height: 40px;
`;

const Group = styled(Box)``;

const GroupTitle = styled.div`
	text-transform: uppercase;
	letter-spacing: 2px;
	font-size: 12px;
	color: ${(props) => props.theme.colors.lightBlueDark};
`;

export default function EmployeesFilters(props: {
	status?: boolean;
	cycles?: boolean;
	jobs?: boolean;
}) {
	const { t } = useTranslation();

	return (
		<Box>
			<Box marginTop={3}>
				<SearchField name="query" type={FieldType.Text} placeholder="Search (name, email)" />
			</Box>
			<Group>
				<GroupTitle>{t('employees.filters.meta.title')}</GroupTitle>
				<EmployeesDepartmentFilter />
				{props.status !== false && <EmployeesStatusFilter />}
				{props.status !== false && <EmployeesExternalFilter />}
				{props.cycles && <EmployeesCycleFilter />}
				{props.jobs && <EmployeesJobFilter />}
			</Group>
		</Box>
	);
}
